import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase';
import { addDoc, collection, doc, getDoc } from 'firebase/firestore';
import BackHomeButton from '../components/BackHomeButton';
import { onAuthStateChanged } from 'firebase/auth';

const FeedbackForm = () => {
  const questions = [
"1. Are you happy with the quality of teaching at the school? ",
"2. Do you feel the school is safe and secure for students?",
"3. Are school staff polite and helpful?",
"4. Is the school clean and well-maintained?",  
"5. Are you satisfied with the communication from the school?",  
"6. Does your child enjoy going to school?",
"7. Are you happy with the school’s online tools or apps?",  
"8. Are the teachers supportive and understanding?",
"9. Do you find the school’s academic schedule manageable?",  
"10. Would you recommend this school to other parents?",
  ];

  const options = [
    "Strongly Agree",
    "Agree",
    "Neither Agree nor Disagree",
    "Disagree",
    "Strongly Disagree"
  ];

  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [welcomePage, setWelcomePage] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [responses, setResponses] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [finalFeedback, setFinalFeedback] = useState('');
  const [showTextFeedback, setShowTextFeedback] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        alert("You must be logged in");
        navigate('/login');
      } else {
        setUser(currentUser);
        fetchUserProfile(currentUser.uid);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const fetchUserProfile = async (uid) => {
    const docRef = doc(db, 'profiles', uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setUserProfile(docSnap.data());
    } else {
      alert("User profile not found!");
    }
  };

  const handleOptionSelect = (option) => {
    setResponses(prev => ({ ...prev, [currentIndex]: option }));
    setSelectedOption(option);

    setTimeout(() => {
      if (currentIndex < questions.length - 1) {
        setCurrentIndex(prev => prev + 1);
      } else {
        setShowTextFeedback(true);
      }
      setSelectedOption(null);
    }, 300);
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prev => prev - 1);
    }
  };

const handleSubmit = async () => {
  try {
    
    await addDoc(collection(db, "schoolfeedbacks"), {
      responses,
      finalFeedback,
      timestamp: new Date(),
      uid: user.uid,
    });

    setIsSubmitted(true);
  } catch (error) {
    console.error("Error adding document: ", error);
  }
};


  const progressPercent = Math.round(((currentIndex + 1) / questions.length) * 100);

  if (isSubmitted) {
    return (
      <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
        <h2>Thank You!</h2>
        <p>Your feedback has been submitted successfully.</p>
        <BackHomeButton />
      </div>
    );
  }

  if (showTextFeedback) {
    return (
      <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
        <h2>Additional Feedback</h2>
        <p>Is there anything else you'd like to share with us?</p>
        <textarea
          rows="5"
          style={{ width: '100%', padding: '10px', borderRadius: '5px', borderColor: '#ccc' }}
          value={finalFeedback}
          onChange={(e) => setFinalFeedback(e.target.value)}
          placeholder="Type your feedback here..."
        />
        <button
          onClick={handleSubmit}
          style={{
            marginTop: '20px',
            background: '#4caf50',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '6px',
            cursor: 'pointer',
            color: '#fff'
          }}
        >
          Submit Feedback
        </button>
      </div>
    );
  }

  if (welcomePage) {
    return (
      <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
        <BackHomeButton />
        <h2>Welcome to the Feedback Form!</h2>
        <p>Your feedback is incredibly important to us! It helps improve the experience for other parents just like you.</p>
        {userProfile && (
          <div>
            <p><strong>User:</strong> {userProfile.name}</p>
            <p><strong>School:</strong> {userProfile.school}</p>
            <p><strong>Standard:</strong> {userProfile.standard}</p>
          </div>
        )}
        <button
          onClick={() => setWelcomePage(false)}
          style={{
            marginTop: '10px',
            background: '#4caf50',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '6px',
            cursor: 'pointer',
            color: '#fff'
          }}
        >
          Start Feedback
        </button>
      </div>
    );
  }

  return (

    
    <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>

    <BackHomeButton
      style={{
        padding: '0.5rem 1rem',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '5px'
      }}
    />

      <h2>Feedback Form</h2>

      <div style={{ background: '#eee', borderRadius: '10px', overflow: 'hidden', height: '10px', marginBottom: '20px' }}>
        <div
          style={{
            width: `${progressPercent}%`,
            height: '100%',
            background: '#4caf50',
            transition: 'width 0.3s ease'
          }}
        />
      </div>

      <p><strong>Question {currentIndex + 1} of {questions.length}</strong></p>
      <p>{questions[currentIndex]}</p>

      {options.map((option, index) => (
        <div key={index} style={{ marginBottom: '10px' }}>
          <button
            onClick={() => handleOptionSelect(option)}
            style={{
              padding: '10px',
              width: '100%',
              borderRadius: '8px',
              border: '1px solid #ccc',
              background: selectedOption === option ? '#4caf50' : '#f9f9f9',
              cursor: 'pointer',
              transition: 'background 0.3s ease'
            }}
          >
            {option}
          </button>
        </div>
      ))}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        {currentIndex > 0 && !isSubmitted ? (
          <button
            onClick={handleBack}
            style={{
              marginTop: '10px',
              background: '#ddd',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Previous Question
          </button>
        ) : (
          <div></div>
        )}

      </div>

      <br />
      <footer style={styles.footer}>
        <p style={styles.footerText}>© 2026 Eascode All Rights Reserved.</p>
      </footer>
    </div>
  );
};

const styles = {
  footer: {
    padding: '1rem',
    backgroundColor: '#333',
    color: '#fff',
    textAlign: 'center',
  },
  footerText: {
    fontSize: '0.9rem',
  },
};

export default FeedbackForm;
